<template>
  <div class="botao_style">
    <p><slot></slot></p>
  </div>
</template>

<script>
export default {
  name: "SaberBotao2",
  props:["backgroundColor","borderColor","textColor"],
}

</script>

<style scoped>

.botao_style {
  background-color: transparent;
  width: 280px;
  border-radius: 4px;
  border: 2px solid v-bind('borderColor');
  /*margin: 0 auto;
  margin-top: 15px;*/
}

.botao_style p {
  font-family: "Montserrat";
  font-size: 16px;
  padding: 10px;
  text-align: center;
  color:v-bind('textColor');
  margin-bottom: 0;

}

.botao_style:hover {
  background-color: v-bind("backgroundColor");
  cursor: pointer;
}

.botao_style:hover > p {
  color: white;
}

/*Responsive - ecrãs desktop pequenos*/
@media (max-width: 1440px) {

}

/*Responsive - ipad*/
@media (max-width: 1025px) {
  .botao_style p {
    font-size: 15px;
    padding: 9px;
  }
}

/*Responsive - iphone*/
@media (max-width: 767px) {
  .botao_style {
    width: 100%;
  }

  .botao_style {
    margin-top: 5px;
    margin-bottom: 25px;
  }




}
</style>